import { apiFetch } from './client';

// Public storefront client — unauthenticated. The token in the URL is the
// credential: /store/{token} for a team store, /store/sell/{token} for a
// member's personal sale link (the sale is attributed to that seller server-
// side, never from the client).

export interface StorefrontVariant {
  id: string;
  sku?: string;
  price_minor: number;
  currency: string;
}

export interface StorefrontProduct {
  id: string;
  title: string;
  description: string;
  variants: StorefrontVariant[];
}

export interface Storefront {
  store_id: string;
  name: string;
  seller_name?: string;
  products: StorefrontProduct[];
}

export async function getStorefront(token: string, seller: boolean): Promise<Storefront> {
  const seg = seller ? 'sell' : 'store';
  return apiFetch<Storefront>(`/api/v1/public/shop/${seg}/${encodeURIComponent(token)}`);
}

export interface ShopCheckoutLine {
  variant_id: string;
  quantity: number;
}

export interface ShopCheckoutResult {
  order_id: string;
  checkout_url?: string;
  swish_qr?: string;
  swish_deep_link?: string;
}

export async function startShopCheckout(
  token: string,
  seller: boolean,
  body: {
    lines: ShopCheckoutLine[];
    method: string;
    buyer: Record<string, string>;
    success_url: string;
    cancel_url: string;
  },
): Promise<ShopCheckoutResult> {
  const seg = seller ? 'sell' : 'store';
  return apiFetch<ShopCheckoutResult>(
    `/api/v1/public/shop/${seg}/${encodeURIComponent(token)}/checkout`,
    { method: 'POST', body },
  );
}
